export enum Units {
    GRAM = "gram",
    PERCENTAGE = "percentage",
    PINCH = "pinch",
    TEASPOON = "teaspoon",
    TABLESPOON = "tablespoon",
    G_PER_KG = "g-per-kg",
    MG_PER_KG = "mg-per-kg",
    MCG_PER_KG = "mcg-per-kg",
    MG = "mg",
    MCG = "mcg",
}
